import { render, staticRenderFns } from "./F202.vue?vue&type=template&id=468f4ffa&scoped=true"
import script from "./F202.vue?vue&type=script&lang=js"
export * from "./F202.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=468f4ffa&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468f4ffa",
  null
  
)

export default component.exports